import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export const STUDIO_NAME = 'Malanka Games';

// Rhombus ornament, a nod to the embroidered patterns of Malanka costumes.
export function Ornament({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" style={{ display: 'block', flexShrink: 0 }}>
      <path d="M8 1 15 8 8 15 1 8Z" fill="none" stroke={color} strokeWidth="1.5" />
      <path d="M8 5 11 8 8 11 5 8Z" fill={color} />
    </svg>
  );
}

// A repeating band of the ornament, used as a quiet section divider.
export function OrnamentBand({ opacity = 0.35 }) {
  const svg = encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12">'
    + '<path d="M6 1 11 6 6 11 1 6Z" fill="none" stroke="#d27a5a" stroke-width="1"/>'
    + '<path d="M18 4 20 6 18 8 16 6Z" fill="#d27a5a"/></svg>',
  );
  return (
    <Box aria-hidden sx={{ height: 12, opacity, backgroundImage: `url("data:image/svg+xml,${svg}")`, backgroundRepeat: 'repeat-x' }} />
  );
}

export function Wordmark({ to = '/', compact = false }) {
  return (
    <Box component={RouterLink} to={to}
      sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.primary', textDecoration: 'none', flexShrink: 0 }}
    >
      <Box sx={{ color: 'primary.main' }}><Ornament size={16} /></Box>
      <Typography sx={{ fontWeight: 600, fontSize: '0.92rem', letterSpacing: '-0.01em' }}>
        {compact ? 'Malanka' : STUDIO_NAME}
      </Typography>
    </Box>
  );
}
